// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cY","cityChooser__text":"c-j_cZ","cityChooser__placeholder":"c-j_ea","cityChooser__buttonIcon":"c-j_eb"};